module.exports = __webpack_public_path__ + "img/follow_title.fb823f74.png";